(()=>{
  const mq=window.matchMedia('(max-width:600px)');
  const toast=()=>{const el=document.getElementById('CmToast');if(!el)return;el.hidden=false;clearTimeout(el._cmTimer);el._cmTimer=setTimeout(()=>{el.hidden=true},2600)};
  const refreshCart=async()=>{try{const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);return cart}catch(e){return null}};
  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const sticky=section.querySelector('[data-sticky-buy]');
    if(!sticky)return;
    const stickyBtn=sticky.querySelector('[data-sticky-add]');
    const stickyPrice=sticky.querySelector('[data-sticky-price]');
    const stickyLabel=sticky.querySelector('[data-sticky-label]');
    const stickyBtnPrice=sticky.querySelector('[data-sticky-button-price]');
    const mainId=section.querySelector('.js-product-form input[name="id"]');
    const mainPrice=section.querySelector('[data-price]');
    const mainBtn=section.querySelector('[data-add-button]');
    let mainButtonVisible=false;
    const sync=()=>{
      const price=mainPrice?mainPrice.textContent.trim():'';
      const variantId=mainId?mainId.value:'';
      const available=!!(mainBtn&&!mainBtn.disabled&&variantId);
      if(stickyPrice&&price)stickyPrice.textContent=price;
      if(stickyBtn){stickyBtn.dataset.variantId=variantId;stickyBtn.disabled=!available}
      if(stickyLabel)stickyLabel.textContent=available?'Add to Cart':'Sold Out';
      if(stickyBtnPrice)stickyBtnPrice.textContent=available&&price?' — '+price:'';
    };
    const visibility=()=>{
      const show=mq.matches&&window.scrollY>260&&!mainButtonVisible;
      sticky.classList.toggle('is-visible',show);
    };
    section.addEventListener('change',()=>setTimeout(sync,0));
    section.addEventListener('input',()=>setTimeout(sync,0));
    if(mainBtn&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{mainButtonVisible=entries.some(entry=>entry.isIntersecting);visibility()},{threshold:.2});
      observer.observe(mainBtn);
    }
    window.addEventListener('scroll',visibility,{passive:true});
    if(mq.addEventListener)mq.addEventListener('change',visibility);
    else if(mq.addListener)mq.addListener(visibility);
    sync();visibility();
    stickyBtn&&stickyBtn.addEventListener('click',async()=>{
      const id=stickyBtn.dataset.variantId;
      if(!id||stickyBtn.disabled)return;
      const oldLabel=stickyLabel?stickyLabel.textContent:'';
      stickyBtn.disabled=true;
      if(stickyLabel)stickyLabel.textContent='Adding…';
      if(stickyBtnPrice)stickyBtnPrice.textContent='';
      try{
        const fd=new FormData();fd.append('id',id);fd.append('quantity','1');
        const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
        if(!res.ok)throw new Error('add');
        const cart=await refreshCart();
        if(cart)document.dispatchEvent(new CustomEvent('crittermode:cart-updated',{detail:{cart,open:true}}));
        toast();
        if(stickyLabel)stickyLabel.textContent='Added ✓';
        setTimeout(sync,1100);
      }catch(e){
        if(stickyLabel)stickyLabel.textContent=oldLabel||'Add to Cart';
        setTimeout(()=>{document.getElementById('shop')?.scrollIntoView({behavior:'smooth',block:'start'});sync()},120);
      }
    });
  });
})();